import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { Fixtures } from '../components/Fixtures';

export const FixturesProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <Fixtures {...data} />
        </Provider>
    );
};

export default FixturesProvider;

FixturesProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
